import type { TOC } from '@ember/component/template-only'

interface Signature {
  Blocks: {
    default: []
  }
}

export const ReportingControls: TOC<Signature> = <template>
  <div data-test-reporting-controls class="mt-3 mb-6 flex flex-wrap items-center justify-center gap-4 print:hidden">
    {{yield}}
  </div>
</template>

export default ReportingControls
